import { BRAND_HOST_MAP, type BrandKey } from '../brands/types';
import { getBrandConfig, normalizeHost, resolveBrand, resolveBrandKey } from '../brands/registry';

const ZUADARIA_HOSTS = new Set(
  Object.entries(BRAND_HOST_MAP)
    .filter(([, key]) => key === 'zuadaria')
    .map(([host]) => host)
);

/** Detecta AZI ADUS / AZIADUS / Zuadaria em nome, slug ou título (legado). */
export function isZuadariaBrandLabel(value?: string | null): boolean {
  if (!value) return false;
  const n = value.toLowerCase().replace(/[\s_-]+/g, '');
  return n.includes('aziadus') || n.includes('zuadaria');
}

export function toZuadariaDisplayName(value?: string | null, fallback = 'Zuadaria'): string {
  if (!value?.trim()) return fallback;
  return isZuadariaBrandLabel(value) ? 'Zuadaria' : value;
}

export function isZuadariaHost(hostname: string = window.location.hostname): boolean {
  return resolveBrandKey({ hostname }) === 'zuadaria' || ZUADARIA_HOSTS.has(normalizeHost(hostname));
}

/** Host Zuadaria OU org AZI ADUS / Zuadaria (funciona no localhost do painel). */
export function isZuadariaUi(opts?: {
  parishName?: string | null;
  parishSlug?: string | null;
  brandKey?: string | null;
}): boolean {
  return (
    resolveBrandKey({
      parishBrandKey: opts?.brandKey,
      legacyLabel: opts?.parishName || opts?.parishSlug,
    }) === 'zuadaria'
  );
}

/** Favicon/título só em hosts de marca (não altera Meu Sacramento). */
export function applyHostBrandChrome(hostname: string = window.location.hostname): void {
  const key = resolveBrandKey({ hostname }) as BrandKey;
  if (key === 'platform') return;

  const brand = getBrandConfig(key);
  document.querySelectorAll("link[rel*='icon']").forEach((el) => el.remove());

  for (const icon of brand.favicons) {
    const el = document.createElement('link');
    el.rel = icon.rel;
    if (icon.type) el.type = icon.type;
    el.href = icon.href;
    if (icon.sizes) el.setAttribute('sizes', icon.sizes);
    document.head.appendChild(el);
  }

  if (!document.title || /evento|sacramento/i.test(document.title)) {
    document.title = brand.documentTitle;
  }
}

export { resolveBrand, resolveBrandKey, getBrandConfig };
